import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { User, Password } from '../../../shared/user.model';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { UserService } from '../../../shared/user.service';


@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit {
  Id: any;
  mode: any;
  title = "Add User"
  data: any;
  roleId:string;
  officeList;
  roleList;
  formSubmitted: boolean;
  user:any;
  password:Password;

  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: UserService) {
    this.user = new User();
    this.formSubmitted = false;
    this.Id=null;
    this.mode=null;
    this.user={};
   
  }

  ngOnInit() {
    this.GetAllRoleNames();
    this.GetRolesforSelectedOffice();
    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.Id = params['Id'];
    });
  }

  GetUserForTheId(Id) {    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getUserForTheId(Id)
      .subscribe(
        (data) => {
          this.user = data;
          this.roleId=this.user.RoleId;
          this.GetRolesforSelectedOffice();
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetAllRoleNames() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllRoleNames();
    this.data.subscribe(
      (response) => {
        this.officeList = response;
        document.getElementById('loader-spinner').style.display = "none";
        if (this.Id != null && this.mode!=null) 
          this.GetUserForTheId(this.Id);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetRolesforSelectedOffice() {
    if (this.user != null) {
      this.user.RoleId=undefined;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getRolesforSelectedOffice();
      this.data.subscribe(
        (response) => {
          this.roleList = response;
          for(let i=0;i<this.roleList;i++){
          if( this.roleList=='Super Admin'){
          this.roleList.RoleName='none'
          } 
        }
          if(this.mode!=null)
            this.user.RoleId=this.roleId;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    }
  }

  onSubmit(form: NgForm) {
   
    if (!form.invalid) {
    document.getElementById('loader-spinner').style.display = "block";
    console.log(form.value);
    this.data = this.userService.registerUser(form.value);
    this.data.subscribe(
      (response:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Saved Successfully!','success');
        this.router.navigate(['/home/user']);
        }, (error:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('',error.error.Message,'warning');
        //this.errorHandler.HandlerError(error);
      });
  }else
  this.formSubmitted = true;
}

update(form: NgForm) {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.changePasswordForTheId(form.value)
    .subscribe(
      (data) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','updated Successfully!','success');
        this.router.navigate(['/home/user']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });

}

}




// WEBPACK FOOTER //
// ./src/app/ultilities/user/user-form/user-form.component.ts